import { Button } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from "react-redux";
import { closeDialog } from "../../../redux/reducers/dialogDispositivo-reducer";
import { useDispatch } from "react-redux";
import { useEffect, useState, Fragment } from "react";
import axios from "axios";
import { useFormik } from "formik";
import * as yup from "yup";
import { dialogCambioPassword, dialogButtonGeneral } from "../../../const/DialogData"
import {notificationOpen}  from "../../../redux/reducers/notification-reducer";
import {cambioPsw} from "../../../const/CardDati"
import handlerError from "../../../functions/handlerError";

const urlBase = process.env.REACT_APP_URL;

const validationSchema = yup.object({
  PasswordAttuale: yup
  .string()
  .required("Campo Obbligatorio"),
  NuovaPassword: yup
  .string()
  .required("Campo Obbligatorio"),
  ConfermaPassword: yup
  .string()
  .required("Campo Obbligatorio"),
});

const DialogCambioPassword = () => {
   
    const dialogState = useSelector((state) => state.dialogCambioPassword);
    const dispatch = useDispatch();
    const [changedRow, setchangedRow] = useState();
    const {rowInfo} = dialogState;

    const initialValues = {
      PasswordAttuale:'',
      NuovaPassword:'',
      ConfermaPassword:''
    };


    const formik = useFormik({
      initialValues,
      validationSchema: validationSchema,
      onSubmit: (values) => {
        setchangedRow(values)
      },
    });
    

    useEffect(() => {
      if (changedRow != null) {
        (async () => {
          let body = changedRow;
  
          const { action, method } = cambioPsw;
          let url = urlBase + action;
          try {
            const response = await axios({
              method: method,
              url,
              data: body,
            });
            if (response.data.ok) {
              dispatch(
                notificationOpen({
                  message: response.data.message,
                  status: response.data.ok,
                  })
                );
                formik.resetForm(initialValues);
                dispatch(closeDialog())
            }
          } catch (error) {
            console.error(error);
            const notificationError = handlerError(error)
            dispatch(notificationOpen(notificationError))
            if (error?.response?.data?.errors != undefined ){
              let keys = Object.keys(error?.response?.data?.errors)
              keys.map(key => {
                formik.setFieldError(key,error?.response?.data?.errors[key] )
              })
            }
          }
        })();
      }
    }, [changedRow]);


    const change = () => {
    
      };

      const closeForm = () => {
        formik.resetForm(initialValues)
        dispatch(closeDialog())
      }
      

const handlerBlur = (e) => {
  if (!e.currentTarget.contains(e.relatedTarget)) {
    closeForm();
  }
}

    return (
        <>
           <Dialog
            open={dialogState.isOpen}
            onClose={() => dispatch(closeDialog())}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth
            onBlur={(e) =>handlerBlur(e)}
          >
            <DialogTitle >{dialogCambioPassword.DialogTitle}</DialogTitle>
            <DialogContent>
              <form onSubmit={formik.handleSubmit}>
                <FormControl fullWidth >
                  <TextField
                    margin="dense"
                    id="PasswordAttuale"
                    label="Password attuale"
                    type="password"
                    fullWidth
                    variant="standard"
                    value={formik.values.PasswordAttuale}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.PasswordAttuale && Boolean(formik.errors.PasswordAttuale)
                    }
                    helperText={
                      formik.touched.PasswordAttuale && formik.errors.PasswordAttuale
                    }
                    inputProps={{
                      autoComplete: 'new-Password',
                      form: {
                        autoComplete: 'off',
                      }
                    }}
                  />
                  <TextField
                    margin="dense"
                    id="NuovaPassword"
                    label="Password nuova"
                    type="password"
                    fullWidth
                    variant="standard"
                    value={formik.values.NuovaPassword}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.NuovaPassword && Boolean(formik.errors.NuovaPassword)
                    }
                    helperText={
                      formik.touched.NuovaPassword && formik.errors.NuovaPassword
                    }
                    inputProps={{
                      autoComplete: 'new-Password',
                      form: {
                        autoComplete: 'off',
                      }
                    }}
                  />
                  <TextField
                    margin="dense"
                    id="ConfermaPassword"
                    label="Conferma password"
                    type="password"
                    fullWidth
                    variant="standard"
                    value={formik.values.ConfermaPassword}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.ConfermaPassword && Boolean(formik.errors.ConfermaPassword)
                    }
                    helperText={
                      formik.touched.ConfermaPassword && formik.errors.ConfermaPassword
                    }
                    inputProps={{
                      autoComplete: 'new-Password',
                      form: {
                        autoComplete: 'off',
                      }
                    }}
                  />
                </FormControl>
                <DialogActions>
                <Button onClick={() => closeForm()}>
                  {dialogButtonGeneral.Cancel}
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => change(rowInfo)}
                    autoFocus
                  >
                    {dialogButtonGeneral.Confirm}
                  </Button>
                </DialogActions>
              </form>
            </DialogContent>
          </Dialog>
        </>
    )
}

export default DialogCambioPassword;
